import React from "react";
import { createRoot } from "react-dom/client";
import { availablePages } from "assets/constants";
import { isDev } from "helpers";
import { App } from "./App";
import "./index.css";

const rootElement = document.getElementById("root");
const root = rootElement && createRoot(rootElement);

if (isDev()) {
  root?.render(
    <DevModeSelector
      setPageName={(pageName: string) => {
        root.render(<App pageName={pageName} />);
      }}
    />
  );
} else {
  availablePages.forEach((page) => {
    const element = document.getElementById(page);
    const pageRoot = element && createRoot(element);
    console.info('*** mobile search form react');
    pageRoot?.render(<App pageName={page} />);
  });
}

function DevModeSelector(props: any) {
  return (
    <div>
      <h1>Development Mode</h1>
      <p>Select a page to load:</p>
      <ul>
        {availablePages.map((page) => (
          <li key={page}>
            <button onClick={() => props.setPageName(page)}>{page}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
